import React from 'react';

import { DasherBoardText, GoalVizEvent, PlayerPositionLong } from '~/core/enums';

import { CommonGCGame } from '../../types';
import Rink from '../rink/Rink';

import IceResurfacer from './components/IceResurfacer';
import PlayerMarker from './components/PlayerMarker/PlayerMarker';

import { IceSheetContainer, PlayerGridContainer, PositionGroup } from './styles';

type Props = {
    game: CommonGCGame;
};

const IceSheet: React.FC<Props> = ({ game }) => {
    const isPowerPlay = game.situation?.homeTeam.strength !== game.situation?.awayTeam.strength;
    return (
        <IceSheetContainer>
            <Rink
                gameId={game.id}
                homeTeam={game.homeTeam}
                awayTeam={game.awayTeam}
                dasherBoardText={isPowerPlay ? DasherBoardText.POWERPLAY : undefined}
                period={game.periodDescriptor?.number}
                eventId="playersOnIce"
                eventType={isPowerPlay ? GoalVizEvent.POWER_PLAY : undefined}
            >
                {game.clock?.inIntermission && <IceResurfacer />}
            </Rink>
            <PlayerGridContainer>
                {Object.keys(game.summary.iceSurface).map((team) =>
                    Object.keys(game.summary.iceSurface[team]).map((pos, i) => (
                        <PositionGroup $isHome={team === 'homeTeam'} $position={PlayerPositionLong[pos]} key={i}>
                            {game.summary.iceSurface[team][pos].map((player) => (
                                <PlayerMarker
                                    player={player}
                                    teamAbbrev={game[team].abbrev}
                                    sweaterNumber={player.sweaterNumber}
                                    isHome={team === 'homeTeam'}
                                    position={PlayerPositionLong[pos]}
                                    key={player.playerId}
                                />
                            ))}
                        </PositionGroup>
                    ))
                )}
            </PlayerGridContainer>
        </IceSheetContainer>
    );
};

export default IceSheet;
